import { render, staticRenderFns } from "./CustomerInsurance.vue?vue&type=template&id=c2c723aa&"
import script from "./CustomerInsurance.vue?vue&type=script&lang=js&"
export * from "./CustomerInsurance.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInsurance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports